import * as server from '../../../Axios'

export const getSolPendParCant = async q => {
  return await server
    .getSolPendParCant(q)
    .then(response => ({ data: response.data }))
    .catch(error => ({ error: error }))
}
